export declare namespace AppMenubarTokenSections {
	interface Item {
		activeFontWeight: string;
	}

	interface MobileButton {
		activeColor: string;
	}
}

export type AppMenubarTokens = {
	item: AppMenubarTokenSections.Item;
	mobileButton: AppMenubarTokenSections.MobileButton;
};

export const item: AppMenubarTokenSections.Item = {
	activeFontWeight: '700',
};

export const mobileButton: AppMenubarTokenSections.MobileButton = {
	activeColor: '{neutral.white}',
};

export default {
	item,
	mobileButton,
} satisfies AppMenubarTokens;
